import * as yup from 'yup';

const ADD_TEAM_SCHEMA = yup.object({
    name: yup.string().required(),
    specialties: yup.array().of(yup.number()).required().min(1),
    members: yup.array().of(yup.number()).required().min(1),
})

export { ADD_TEAM_SCHEMA }